import forza5 from '../../assets/game-covers/forza5.jpeg'
import battlefield2042 from '../../assets/game-covers/Battlefield2042.webp'
import lifeisstrangetruecolors from '../../assets/game-covers/LifeisStrangeTrueColors.webp'
import gta5 from '../../assets/game-covers/Gta5.webp'
import tomclancysrainbowsix from '../../assets/game-covers/RainbowSix.webp'
import assassinscreedvalhalla from '../../assets/game-covers/AssassinsCreedValhalla.webp'

export const GAMES = [
  {
      image: forza5,
      title: 'Forza Horizon 5',
      genres: ['Racing', 'Simulator', 'Open world'],
      price: 55,
      video: 'https://www.youtube.com/embed/FYH9n37B7Yw',
      id: 1,
      description: "Forza Horizon 5 is a racing video game set in an open world environment based in a fictional representation of Mexico. The game has the largest map in the entire Forza Horizon series, being 50% larger than its predecessor, Forza Horizon 4, while also having the highest point in the Horizon series. The map was described by creative director Mike Brown as one of the most diverse Forza Horizon maps the team has built. The map contains an active caldera volcano, jungles and beaches, ancient Mayan temples, and towns and cities such as Guanajuato.",
  },
  {
      image: battlefield2042,
      title: 'Battlefield 2042',
      genres: ['Action', 'Shooter', 'Warner'],
      video: 'https://www.youtube.com/embed/ASzOzrB-a9E',
      price: 65,
      id: 2,
      description: 'Battlefield 2042 is a multiplayer-focused first-person shooter. As the game is set in the near future, it features futuristic weapons and gadgets like deployable turrets and drones, as well as vehicles that players can control. Players can request a vehicle air-drop to any location. The game introduced a "Plus" system which allows players to customize their weapons on the spot. The class system is significantly overhauled and removes the four defined classes from previous games; instead, players can assume control of a specialist who falls under the four traditional Battlefield gameplay classes of Assault, Engineer, Medic, and Recon. '
  },
  {
      image: lifeisstrangetruecolors,
      title: 'Life is Strange True Colors',
      genres: ['Adventure', 'Point-to-click'],
      video: 'https://www.youtube.com/embed/b6CkzwVAr0M',
      price: 50,
      id: 3,
      description: 'Life Is Strange: True Colors is a graphic adventure played from a third-person view. The player controls the protagonist, Alex Chen, to explore various locations in the fictional setting of Haven Springs and communicate with non-playable characters through the conversation system based on dialogue trees.'
  },
  {
      image: gta5,
      title: 'Grand Theft Auto V',
      genres: ['Open world', 'Action'],
      video: 'https://www.youtube.com/embed/QkkoHAzjnUs',
      price: 45,
      id: 4,
      description: 'Grand Theft Auto V is an action-adventure game played from either a third-person or first-person perspective. Players complete missions—linear scenarios with set objectives—to progress through the story. Outside of the missions, players may freely roam the open world. Composed of the San Andreas open countryside area, including the fictional Blaine County, and the fictional city of Los Santos, the world is much larger in area than earlier entries in the series. It may be fully explored after the gameʼs beginning without restriction, although story progress unlocks more gameplay content.'
  },
  {
      image: tomclancysrainbowsix,
      title: 'Tom Clancyʼs Rainbow Six® Siege',
      video: 'https://www.youtube.com/embed/6wlvYh0h63k',
      genres: ['Tactical', 'Shooter'],
      price: 40,
      id: 5,
      description: 'Tom Clancyʼs Rainbow Six Siege is a first-person shooter game, in which players utilize many different operators from the Rainbow team. Different operators have different nationalities, weapons, and gadgets. The game features an asymmetrical structure whereby the teams are not always balanced in their choices of abilities.'
  },
  {
      image: assassinscreedvalhalla,
      title: 'Assassin’s Creed Valhalla',
      genres: ['Action', 'RPG', 'Open world'],
      video: 'https://www.youtube.com/embed/ssrNcwxALS4',
      price: 55,
      id: 6,
      description: 'Assassinʼs Creed Valhalla is an action role-playing video game structured around several main story arcs and numerous optional side-missions, called "World Events". The player takes on the role of Eivor Varinsdottir, a Viking raider, as they lead their fellow Vikings against the Anglo-Saxon kingdoms.'
  },
]
